<!--
  Copyright (C) 2022 - Jeci SARL - https://jeci.fr

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see https://www.gnu.org/licenses/agpl-3.0.html.
-->

<template>
  <div :class="containerClass" @click="onWrapperClick">
    <Toast position="bottom-right" />
    <AppTopBar @menu-toggle="onMenuToggle" />
    <div class="layout-sidebar" @click="onSidebarClick">
      <AppMenu :model="menu" @menuitem-click="onMenuItemClick" />
    </div>

    <div class="layout-main-container">
      <div class="layout-main">
        <router-view @fullsize="onFullSize" @hideFooter="hideFooter" />
      </div>
      <AppFooter v-if="this.displayFooter" />
    </div>

    <transition name="layout-mask">
      <div class="layout-mask p-component-overlay" v-if="mobileMenuActive" />
    </transition>
  </div>
</template>

<script>
import AppTopBar from "./AppTopbar.vue";
import AppMenu from "./AppMenu.vue";
import AppFooter from "./AppFooter.vue";
import { useMenuStore, menuService } from "@pristy/pristy-libvue";

export default {
  emits: ["change-theme"],
  data() {
    return {
      staticMenuInactive: false,
      mobileMenuActive: false,
      menu: null,
      displayFooter: true,
    };
  },
  created() {
    this.menuStore = useMenuStore();
    this.menu = this.menuStore.menu;
    this.getMenu();
  },
  mounted() {
    this.menuStore.$subscribe((mutation, state) => {
      this.menu = state.menu;
    });
  },
  methods: {
    getMenu() {
      menuService.computeMenuEspaces().then((computedMenu) => {
        this.menu = computedMenu;
        this.menuStore.$patch({ menu: computedMenu });
      });
    },
    onWrapperClick() {
      if (!this.menuClick) {
        this.mobileMenuActive = false;
      }

      this.menuClick = false;
    },
    onFullSize() {
      this.staticMenuInactive = true;
      this.mobileMenuActive = false;
    },
    hideFooter() {
      this.displayFooter = false;
    },
    onMenuToggle() {
      this.menuClick = true;

      if (this.isDesktop()) {
        this.staticMenuInactive = !this.staticMenuInactive;
      } else {
        this.mobileMenuActive = !this.mobileMenuActive;
      }
      event ? event.preventDefault() : null;
    },
    onSidebarClick() {
      this.menuClick = true;
    },
    onMenuItemClick(event) {
      if (event.item && !event.item.items) {
        this.mobileMenuActive = false;
      }
    },
    addClass(element, className) {
      if (element.classList) {
        element.classList.add(className);
      } else {
        element.className += " " + className;
      }
    },
    removeClass(element, className) {
      if (element.classList) {
        element.classList.remove(className);
      } else {
        element.className = element.className.replace(
          new RegExp(
            "(^|\\b)" + className.split(" ").join("|") + "(\\b|$)",
            "gi"
          ),
          " "
        );
      }
    },
    isDesktop() {
      return window.innerWidth >= 1081;
    },
  },
  computed: {
    containerClass() {
      return [
        "layout-wrapper",
        {
          "layout-static": true,
          "layout-static-sidebar-inactive": this.staticMenuInactive,
          "layout-mobile-sidebar-active": this.mobileMenuActive,
          "p-input-filled": this.$primevue.config.inputStyle === "filled",
          "p-ripple-disabled": this.$primevue.config.ripple === false,
        },
      ];
    },
    logo() {
      return this.$appState.darkTheme
        ? "images/logo-white.svg"
        : "images/logo.svg";
    },
  },
  beforeUpdate() {
    if (!this.isDesktop()) {
      if (this.mobileMenuActive) {
        this.addClass(document.body, "body-overflow-hidden");
      } else {
        this.removeClass(document.body, "body-overflow-hidden");
      }
    }
  },
  components: {
    AppTopBar,
    AppMenu,
    AppFooter,
  },
};
</script>

<style lang="scss">
@import "./App.scss";
</style>
